import { render } from "./CustomLoader.vue?vue&type=template&id=7c5695b9&scoped=true"
const script = {}

import "./CustomLoader.vue?vue&type=style&index=0&id=7c5695b9&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.35_vue@3.4.35_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5695b9"]])

export default __exports__